import { BoxProps } from "@mui/material";
import React from "react";

import { UserChatBubble } from "./ChatBubbles";

type UserQuestionChatBubbleProps = {
  question: string;
} & BoxProps;

export const UserQuestionChatBubble: React.FC<UserQuestionChatBubbleProps> = ({
  question,
  ...props
}) => {
  return (
    <UserChatBubble
      {...props}
      sx={{
        "& > p:first-of-type": {
          marginTop: 0,
        },
        "& > p:last-of-type": {
          marginBottom: 0,
        },

        ...props.sx,
      }}
    >
      {question.split("\n").map((line, index) => (
        <p key={index}>{line}</p>
      ))}
    </UserChatBubble>
  );
};
